import api from "./instance";

export default {
  getUpsellAnalytics: (token, cinemaId, startDate, endDate) =>
    api
      .get(
        `/upsell-analytics?cinema_id=${cinemaId}&start_date=${startDate}&end_date=${endDate}`,
        {
          headers: { Authorization: token }
        }
      )
      .then(res => res),
  getUpsells: (token, cinemaId, page, search) =>
    api
      .get(
        search?.length >= 3
          ? `/upsell-mappings?cinema_id=${cinemaId}&page=${page}&perPage=10&search=${search}`
          : `/upsell-mappings?cinema_id=${cinemaId}&page=${page}&perPage=10`,
        {
          headers: { Authorization: token }
        }
      )
      .then(res => res),
  updateUpsell: (token, upsellId, data) =>
    api
      .put(`/upsell-mappings/${upsellId}`, data, {
        headers: { Authorization: token }
      })
      .then(res => res),
  deleteUpsell: (token, upsellId) =>
    api
      .delete(`/upsell-mappings/${upsellId}`, {
        headers: { Authorization: token }
      })
      .then(res => res),

  createManualUpsell: (token, data) =>
    api.post("/upsell-mappings", data, {
      headers: { Authorization: token }
    }),

  createSmartUpsell: (token, data) =>
    api.post("/upsell-mappings", data, {
      headers: { Authorization: token }
    })
};
